export default __webpack_public_path__ + "images/E6.297c54f.png";